var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"m-br"},[(_vm.m)?_c('br',{staticClass:"except-pc"}):_c('br',{staticClass:"pc-only"})])}
var staticRenderFns = []

export { render, staticRenderFns }